import moment from "moment";

const planListColumns = [
  {
    title: "Plan Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Total Employees",
    dataIndex: "total_user",
    key: "total_user",
  },
  {
    title: "Duration",
    dataIndex: "duration",
    key: "duration",
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (value) => `₹ ${value}`, // ✅ optional: add currency symbol
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
 
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
  },

];

export default planListColumns;
